import React, { Component, Fragment } from "react";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import TextBox from "../../../components/atoms/TextBox";
import DatePicker from "../../../components/atoms/DatePicker";
import ComboBox from "../../../components/atoms/ComboBox";
import TextArea from "../../../components/atoms/TextArea";
import Button from "../../../components/atoms/Button";
import RadioButton from "../../../components/atoms/RadioButton";
import FormRegion from "../../organism/FormRegion";
import dateFormatIndo from "../../../utils/helpers/dateFormatIndo";
import SelectFiles from "../../../components/atoms/SelectFiles";
import axios from "axios";
import { BASE_URL } from "../../../config";

export class DataPic extends Component {
	_isMounted = false;
	constructor(props) {
		super(props);

		this.state = {
			cid_file: {
				loading: false,
				fileNew: "",
			},
			selfie_file: {
				loading: false,
				fileNew: "",
			},
			data: {},
			nationality: [],
			gender: [],
		};
	}

	updateState = ({ name, value, type }) => {
		let { data } = this.state;
		if (type === "number") {
			value = value.replace(/\D/g, "");
		}
		if (name === "province") {
			data.province = value.province;
			data.provinceCode = value.provinceCode;
		} else if (name === "city") {
			data.city = value.city;
			data.cityCode = value.cityCode;
		} else if (name === "subdistrict") {
			data.subdistrict = value.subdistrict;
			data.subdistrictCode = value.subdistrictCode;
		} else if (name === "addressKel") {
			data.addressKel = value.addressKel;
			data.addressKelCode = value.addressKelCode;
		} else {
			data[name] = value;
		}
		// console.log({name, value});
		// console.log("current dara : ", {data});

		this.setState({ data });
	};
	componentWillUnmount = () => {
		this._isMounted = false;
	};
	componentDidMount = () => {
		this._isMounted = true;
		const { col, parameters, profileState } = this.props;
		if (parameters) {
			this.setDataPIC();
		}
	};
	setDataPIC = () => {
		const { col, parameters, profileState } = this.props;
		// console.log("wah apani = ", {pro : profileState.list.picDetail});

		this.setState({ nationality: parameters.nationality });
		let { data } = this.state;
		let dataPIC = profileState.list.picDetail;
		for (let key in dataPIC) {
			if (dataPIC[key]) {
				data[key] = dataPIC[key];
			}
		}
		data.nationality = "WNI";
		data.country = "Indonesia";
		data.identificationDocumentType = "KTP";
		const transformedGender = parameters.gender && parameters.gender.map(({ paramValue, paramName }) => ({ value: paramValue, text: paramName, checked: false }));
		transformedGender &&
			this.setState({ gender: transformedGender }, () => {
				if (data.gender) {
					this.changeGender(data.gender);
				} //dateFormatIndo
			});
		// console.log({transformedGender, profileState});
		// console.log("data pic did == ", {data});
		if (data.birthDate) {
			this.changeDate({ name: "birthDate", value: new Date(data.birthDate) });
		}
		this.setState({ data });
	};
	changeGender = (value) => {
		let { gender } = this.state;
		// console.log("change gender - ",{value, gender});
		for (let i = 0; i < gender.length; i++) {
			if (gender[i].value === value) {
				// console.log("ini bener");
				gender[i].checked = true;
			} else {
				gender[i].checked = false;
			}
		}
		this.setState({ gender });
		this.updateState({ name: "gender", value });
	};
	changeDate = ({ name, value }) => {
		this.setState({ [name]: value });
		this.updateState({ name, value: dateFormatIndo(value, "db") });
	};
	submitPIC = () => {
		// console.log("masuk submit");

		this.props.submit(this.state.data, this.setDataPIC);
	};

	uploadFile = (name, value) => {
		const { RefreshToken, GetTokenCIF, setNewTokenCIF } = this.props;
		let stateSelected = this.state[name];
		stateSelected.loading = true;
		if (this._isMounted) {
			this.setState({ [name]: stateSelected });
		}

		RefreshToken((ClientID) => {
			if (ClientID) {
				GetTokenCIF({ ClientID }, (newToken) => {
					setNewTokenCIF(newToken);

					let formData = new FormData();
					formData.append(name, value);
					axios({
						method: "patch",
						url: `${BASE_URL}/borrower/profile/person-in-charge/files`,
						data: formData,
						withCredentials: true,
						headers: {
							Authorization: "Bearer " + newToken,
						},
					}).then(({ data }) => {
						stateSelected.loading = false;
						stateSelected.fileNew = name == "cid_file" ? data.result.identificationFileUID : data.result.selfieFileUID;
						if (this._isMounted) {
							this.setState({ [name]: stateSelected });
						}
					});
				});
			}
		});
	};

	getFiles = (name) => {
		const { RefreshToken, GetTokenCIF, setLoadingPage, setNewTokenCIF } = this.props;
		const { data, cid_file, selfie_file } = this.state;
		let fileId;
		if (name == "cid_file") {
			fileId = cid_file.fileNew ? cid_file.fileNew : data.identificationFileUID;
		} else {
			fileId = selfie_file.fileNew ? selfie_file.fileNew : data.selfieFileUID;
		}

		setLoadingPage(true);
		RefreshToken((ClientID) => {
			GetTokenCIF({ ClientID }, (newToken) => {
				setNewTokenCIF(newToken);

				axios({
					method: "get",
					url: `${BASE_URL}/document/underwrite/${fileId}`,
					headers: {
						Authorization: "Bearer " + newToken,
					},
				}).then(({ data }) => {
					setLoadingPage(false);
					window.open(data.result.document.underwrite.url);
				});
			});
		});
	};

	render() {
		const { col } = this.props;
		const { gender, data, birthDate, cid_file, selfie_file } = this.state;

		return (
			<Fragment>
				{data.nationality && (
					<Fragment>
						{/* <p>{JSON.stringify(profileState.list.picDetail)}</p> */}
						<LabelWithInput label="Nama" col={col} {...this.props} note={null}>
							<TextBox name="nama_pic" value={data.fullName || ""} onChange={(e) => this.updateState({ name: "fullName", value: e.target.value })} />
						</LabelWithInput>

						<LabelWithInput label="Jenis Kelamin" col={col} {...this.props} note={null}>
							<RadioButton onChange={(e) => this.changeGender(e.value)} name="jenkel" data={gender} />
						</LabelWithInput>

						<LabelWithInput label="Jabatan" col={col} {...this.props} note={null}>
							<TextBox name="jabatan" value={data.jobPosition || ""} onChange={(e) => this.updateState({ name: "jobPosition", value: e.target.value })} />
						</LabelWithInput>

						<LabelWithInput label="No. KTP" col={col} {...this.props} note={null}>
							<TextBox name="ktp" type={"number"} value={data.identificationNumber || ""} onChange={(e) => this.updateState({ name: "identificationNumber", value: e.target.value, type: "number" })} />
						</LabelWithInput>

						<LabelWithInput label="Foto KTP" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 5 MB">
							<SelectFiles
								name="cid_file"
								files={data.identificationFileUID || cid_file.fileNew ? (name) => this.getFiles(name) : ""}
								extention=".png,.jpg,.jpeg"
								onChange={(name, value) => {
									this.uploadFile(name, value);
								}}
								loading={cid_file.loading}
								error={null}
							/>
						</LabelWithInput>

						<LabelWithInput label="Foto Selfie" col={col} {...this.props} info="File berformat PDF, JPG, JPEG, PNG dengan ukuran maks. 5 MB">
							<SelectFiles
								name="selfie_file"
								files={data.selfieFileUID || selfie_file.fileNew ? (name) => this.getFiles(name) : ""}
								extention=".png,.jpg,.jpeg"
								onChange={(name, value) => {
									this.uploadFile(name, value);
								}}
								loading={selfie_file.loading}
								error={null}
							/>
						</LabelWithInput>

						<LabelWithInput label="Kewarganegaraan" col={col} {...this.props} note={null}>
							<TextBox name="jabatan" value={data.nationality || ""} isDisabled />
						</LabelWithInput>

						<LabelWithInput label="Kota Tempat Lahir" col={col} {...this.props} note={null}>
							<TextBox name="tempat_lahir" value={data.birthPlace || ""} onChange={(e) => this.updateState({ name: "birthPlace", value: e.target.value })} />
						</LabelWithInput>

						<LabelWithInput label="Tanggal Lahir" col={col} {...this.props} note={null}>
							<DatePicker name="tgl_lahir" onChange={(e) => this.changeDate({ name: "birthDate", value: e.value })} value={birthDate} />
						</LabelWithInput>

						<LabelWithInput label="Negara" col={col} {...this.props} note={null}>
							<TextBox name="negara" value={data.country || ""} isDisabled />
						</LabelWithInput>

						<FormRegion col={col} changeState={this.updateState} data={data} />

						<LabelWithInput label="Alamat" col={col} {...this.props} note={null}>
							<TextArea name="alamat" value={data.address || ""} onChange={(e) => this.updateState({ name: "address", value: e.target.value })} />
						</LabelWithInput>

						<div className="bg-button add-margin">
							<Button onClick={this.submitPIC} width="big" color="blue" title="Selanjutnya" />
						</div>
					</Fragment>
				)}
			</Fragment>
		);
	}
}

export default DataPic;
